import { Form, Input, Select } from "antd";
import { Modal } from "Components/General/Modal/GenericModal";
import { Button } from "Components/General/Button";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { I18N_NS } from "Config/i18n";
import { useTranslation } from "react-i18next";

export interface SystemRolesOverviewTableModalProps extends ModalComponentProps {
  isVisible: boolean;
  toggleModal: () => void;
  onRoleUpdate: (userid: string, recht: string) => void;
}

export const SystemRolesOverviewTableModal = ({
  isVisible,
  toggleModal,
  onRoleUpdate,
}: SystemRolesOverviewTableModalProps) => {
  const { t } = useTranslation([I18N_NS.PROJECT, I18N_NS.ADMIN]);

  const onFinish = (values) => {
    onRoleUpdate(values.userId, values.recht);
  };

  return (
    <Modal
      title={t("New System Role")}
      open={isVisible}
      footer={null}
      width={`100%`}
      destroyOnHidden={true}
      style={{ maxWidth: 500 }}
      onCancel={toggleModal}
    >
      <Form requiredMark={true} onFinish={onFinish} layout="vertical">
        <Form.Item
          rules={[{ required: true, message: t("This field is required") }]}
          label={t("User ID or Login name")}
          name="userId"
        >
          <Input allowClear={true} autoFocus={true} />
        </Form.Item>
        <Form.Item
          rules={[{ required: true, message: t("This field is required") }]}
          label={t("Role")}
          name="recht"
          initialValue={"ADMIN"}
        >
          <Select>
            <Select.Option value="ADMIN">ADMIN</Select.Option>
            <Select.Option value="SUP">SUP</Select.Option>
            <Select.Option value="VERWALTUNG">VERWALTUNG</Select.Option>
            <Select.Option value="TECH">TECH</Select.Option>
            <Select.Option value="STATUS">STATUS</Select.Option>
          </Select>
        </Form.Item>
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
          <Button style={{ marginRight: 10 }} onClick={toggleModal}>
            {t("Cancel")}
          </Button>
          <Button htmlType="submit" type="primary">
            {t("Assign")}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};
